import { FC, useState, useEffect } from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";
type Props = {
  steps: { threshold: number; message: string | React.ReactNode }[];
  totalDurationSeconds?: number;
  isConversionInProgress: boolean;
};

const ProgressBarWithStepUpdates: FC<Props> = ({
  steps,
  totalDurationSeconds = 35,
  isConversionInProgress,
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isConversionInProgress) {
      setProgress(99);
    }
  }, [isConversionInProgress]);

  useEffect(() => {
    setProgress(0);
    const totalDuration = totalDurationSeconds * 1000;
    const intervalTime = 400;
    const baseIncrement = 100 / (totalDuration / intervalTime);
    let currentProgress = 0;
    const maxPercent = 96;

    const interval = setInterval(() => {
      if (Math.random() > 0.2) {
        const randomVariation = Math.random() * 1.5 + 0.25;
        const increment = baseIncrement * randomVariation;

        const jumpMultiplier = Math.random() < 0.1 ? 3 : 1;
        currentProgress = Math.min(
          maxPercent,
          currentProgress + increment * jumpMultiplier,
        );
        setProgress(currentProgress);
      }

      if (currentProgress >= maxPercent) {
        clearInterval(interval);
      }
    }, intervalTime);

    return () => {
      clearInterval(interval);
      setProgress(100);
    };
  }, []);

  const currentStep =
    steps.findLast((step) => progress >= step.threshold) || steps[0];

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4">
      <Text variant="compact-title" className="text-gray-8">
        {currentStep.message}
      </Text>
      <div className="mt-2 flex w-64 flex-col gap-1">
        <Text
          variant="fine-print-description"
          className={cn("text-gray-8", "text-right")}
        >
          {Math.round(progress)}%
        </Text>
        <div className="relative">
          <div className="absolute h-1 w-full rounded-full bg-gray-2"></div>
          <div
            className="absolute h-1 rounded-full bg-blue-8"
            style={{
              width: `${progress}%`,
              transition: "width 400ms ease-in-out",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBarWithStepUpdates;
